export enum TYPE_LOGIN_ENUM {
  none = 'NONE',
  metamask = 'METAMASK',
}

export enum TRANSACTION_CONTENT_ENUM {
  ALL = 'ALL',
  FEE = 'FEE',
  COIN = 'COIN',
  RESOURCE = 'RESOURCE',
  OBJECT = 'OBJECT',
  SYSTEM_OBJ = 'SYSTEM_OBJ',
  ADVISOR = 'ADVISOR',
}

export enum TRANSACTION_TYPE_ENUM {
  ALL = 'ALL',
  BUY = 'BUY',
  SELL = 'SELL',
  DEPOSIT = 'DEPOSIT',
  WITHDRAW = 'WITHDRAW',
}

export enum TRANSACTION_STATUS_ENUM {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
}
